import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { captureUtmParams } from "@/lib/utm";

// Capture UTM / gclid / fbclid params from PPC landing URL on first load
captureUtmParams();

const LandingPage = lazy(() => import("@/pages/LandingPage"));
const LandingPageIoT = lazy(() => import("@/pages/LandingPageIoT"));
const LandingPageAlt = lazy(() => import("@/pages/LandingPageAlt"));
const AdminChat = lazy(() => import("@/pages/AdminChat"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div style={{ minHeight: "100vh", background: "#1B2030" }} />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/proactive-communicative-cleaning" element={<LandingPage />} />
          <Route path="/iot-cost-saving" element={<LandingPageIoT />} />
          <Route path="/proactive-communicative-cleaning-f" element={<LandingPageAlt />} />
          <Route path="/admin/chat" element={<AdminChat />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
